/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Trash2 } from 'lucide-react';
import ConfirmDialog from '../../components/ConfirmDialog';

function DeleteModal({ policyName, setShowModal, callback, type, date = '' }) {
  return (
    <ConfirmDialog
      tone="danger"
      icon={<Trash2 size={24} />}
      title={`Delete this ${type}?`}
      description={`You're about to delete the "${policyName}" ${type}${date ? ` ${date}` : ''}. This action cannot be undone.`}
      confirmLabel="Delete"
      cancelLabel="Cancel"
      onConfirm={() => callback()}
      onCancel={() => setShowModal(false)}
    />
  );
}

DeleteModal.propTypes = {
  policyName: PropTypes.string.isRequired,
  setShowModal: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  date: PropTypes.string,
};

DeleteModal.defaultProps = { date: '' };

export default DeleteModal;
